
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { DimensionModel } from '@/models/dimension';
import { AnalyticsTypeModel } from '@/models/analytics_type';
import { FilterColumnList } from '@/collections/filter_columns';
import { FilterColumnModel } from '@/models/filter_column';
import { FilterDimensionList } from '@/collections/filter_dimensions';
import { DimensionList } from '@/collections/dimensions';
import dateFormat from 'dateformat';
import { EventBus } from '@/main';
import ActionButton from '@/components/ActionButton.vue';

@Component({
  components: {
    ActionButton,
  },
})
export default class FilterColumn extends Vue {
  @Prop({ default: () => new DimensionList() })
  public dimensions!: DimensionList;
  @Prop({ default: () => new DimensionModel() })
  public dimension!: DimensionModel;
  @Prop({ default: () => new AnalyticsTypeModel() })
  public analyticsType!: AnalyticsTypeModel;
  @Prop({ default: null })
  public value!: FilterColumnList;
  @Prop({ default: () => [] })
  public reportColumns!: any;
  public columnFilterMenu: boolean = false;
  @Prop({ default: false })
  public showColumnFilterMenu!: boolean;
  @Prop({ default: '60vh' })
  public menuMaxHeight!: string;
  public operators: any = [];
  @Prop({ default: null })
  public initFilters!: FilterColumnList;
  public filters: FilterColumnList = new FilterColumnList();
  public filterForms: any = [];
  public errorMessage: string = '';
  public filterDimensionValues: any = [];
  public filterLoading: boolean = false;
  public search: string[] = [];
  public loading: boolean[] = [];
  public currentSearchIndex: number = -1;
  public currentSearchCode: string = '';
  public nameRules: any = [
    this.isNameExist,
  ];
  @Prop({default: 0})
  public customReportId!: number;
  @Prop({default: 0})
  public templateReportId!: number;
  @Prop({default: true})
  public showSelectStore!: boolean;
  public isApplying: boolean = false;
  public searchTimeouts: Map<number, any> = new Map();
  public searchDebounceDelay: number = 400; // milliseconds
  public pendingSearches: Set<number> = new Set();

  public created() {
    this.operators = [
      { name: 'Equal', value: 'eq' },
      { name: 'Not equal', value: 'ne' },
      { name: 'Contains', value: 'contains' },
      { name: 'Does not contain', value: 'notContains' },
      { name: 'Is blank', value: 'null' },
      { name: 'Is not blank', value: 'notNull' },
      { name: 'Is lower than', value: 'lt' },
      { name: 'Is lower than or equal to', value: 'lte' },
      { name: 'Is greater than', value: 'gt' },
      { name: 'Is greater than or equal to', value: 'gte' },
    ];
    this.assignInitFilter();
    EventBus.$on('add-new-filter', async (filter: any) => {
      this.addNewFilter(filter);
    });

    EventBus.$on('clear-filter-column', () => {
      this.clearFilter();
    });
  }

  public isNameExist(v: any) {
    return !!v || 'Name is required';
  }

  public getShortText(selectedValue: string, maxLength: number = 25) {
    if (selectedValue && selectedValue.length > maxLength) {
      return `${selectedValue.substring(0, maxLength)}...`;
    } else {
      return selectedValue;
    }
  }

  public get isAddedStoreLocation() {
    for (const item of this.filterForms) {
      if (item.filter.code === 'Location[Location]') {
        return true;
      }
    }
    return false;
  }
  public getOperatorText(value: string) {
    for (const item of this.operators) {
      if (item.value === value) {
        return item.name;
      }
    }
    return '';
  }
  public assignInitFilter() {
    if (this.initFilters && this.initFilters.items && this.initFilters.items.length > 0) {
      const filterForms: any = [];
      let data: any;
      let index = 0;
      for (const item of this.initFilters.items) {
        const values: string[] = [];
        // Handle both single values and arrays
        if (item.value !== null && item.value !== undefined) {
          if (Array.isArray(item.value)) {
            for (const v of item.value) {
              values.push(v);
            }
          } else {
            // Single value - just add it to the array
            values.push(item.value);
          }
        }
        data = { name: item.name, code: item.code, value: values, operator: item.operator, dataType: item.dataType };
        filterForms.push({filter: new FilterColumnModel(data), loading: false, search: '', dimensionValues: []});
        this.loadFilterDimensionListValue('', index, item.code);
        index = index + 1;
      }
      this.filterForms = filterForms;
    }
  }

  public get filtersCount() {
    let count: number = 0;
    if (this.value && this.value.items && this.value.items.length > 0) {
      count = this.value.items.length;
      if (count > 0) {
        return ' (' + count + ' actives)';
      }
    }
    return '';
  }

  public deleleFilter(index: number) {
    // Clear any pending search for this filter
    if (this.searchTimeouts.has(index)) {
      clearTimeout(this.searchTimeouts.get(index));
      this.searchTimeouts.delete(index);
    }
    
    // Clear pending search indicator
    this.pendingSearches.delete(index);
    
    this.filterForms.splice(index, 1);
    this.currentSearchIndex = -1;
    
    // Reindex the search timeouts and pending searches after deletion
    const newTimeouts = new Map();
    this.searchTimeouts.forEach((timeout, oldIndex) => {
      if (oldIndex > index) {
        newTimeouts.set(oldIndex - 1, timeout);
      } else if (oldIndex < index) {
        newTimeouts.set(oldIndex, timeout);
      }
    });
    this.searchTimeouts = newTimeouts;
    
    // Reindex pending searches
    const newPendingSearches = new Set<number>();
    this.pendingSearches.forEach((oldIndex) => {
      if (oldIndex > index) {
        newPendingSearches.add(oldIndex - 1);
      } else if (oldIndex < index) {
        newPendingSearches.add(oldIndex);
      }
    });
    this.pendingSearches = newPendingSearches;
    
    if (this.filterForms.length === 0) {
      this.addDefaultFilter();
    }
  }
  public deleteActiveFilter(index: number) {
    this.deleleFilter(index);
    this.applyFilter();
  }

  public deleteAddedFilter(index: number) {
    this.deleleFilter(index);
    this.applyFilter();
  }

  public clearFilter() {
    // Clear all pending searches
    this.clearAllSearchTimeouts();
    
    this.errorMessage = '';
    this.columnFilterMenu = false;
    const selectedFilters: FilterColumnList = new FilterColumnList();
    this.filterForms = [];
    this.currentSearchIndex = -1;
    this.currentSearchCode = '';
    this.$emit('input', selectedFilters);
    this.$emit('not-reset-filter-column', false);
    this.addDefaultFilter();
  }

  public addEditingFilterInputValue() {
    // Loop through all filter forms to capture any uncommitted search values
    for (let index = 0; index < this.filterForms.length; index++) {
      const filterForm = this.filterForms[index];
      if (filterForm && filterForm.search !== null && filterForm.search !== '' && filterForm.search !== undefined) {
        // Check if this value doesn't already exist in the filter values
        const searchValue = filterForm.search.trim();
        if (searchValue && !filterForm.filter.value.includes(searchValue)) {
          filterForm.filter.value.push(searchValue);
        }
        // Clear the search input after adding it
        filterForm.search = '';
      }
    }
  }

  public async applyFilter() {
    try {
      this.isApplying = true;
      // Cancel all pending searches
      this.clearAllSearchTimeouts();
      // Blur any active inputs to ensure values are committed
      await this.blurAllFilterInputs();
      // Add any uncommitted search values
      this.addEditingFilterInputValue();
      const selectedFilters: FilterColumnList = new FilterColumnList();
      let data: any;
      for (const item of this.filterForms) {
        const filter = item.filter;
        if (filter.code && item.filter.operator) {
          if (filter.operator === 'null' || filter.operator === 'notNull' || filter.value.length > 0 ) {
            const filterName = this.getFilterColumnName(item.filter.code);
            const filterDataType = this.getFilterColumnDataType(filter.code);
            const values: string[] = [];
            for (const v of filter.value) {
              values.push(v);
            }
            data = {
              name: filterName,
              code: filter.code,
              value: values,
              operator: filter.operator,
              dataType: filterDataType,
            };
            selectedFilters.add(new FilterColumnModel(data));
          }
        }
      }

      this.$emit('input', selectedFilters);
      EventBus.$emit('reset-active-filter-view');
      this.errorMessage = '';
      this.columnFilterMenu = false;
    } finally {
      this.isApplying = false;
    }
  }

  public getSelectedFilter() {
    const selectedFilters: FilterColumnList = new FilterColumnList();
    let data: any;
    for (const item of this.filterForms) {
      const filter = item.filter;
      if (filter.code && item.filter.operator) {
        if (filter.operator === 'null' || filter.operator === 'notNull' || filter.value.length > 0 ) {
          const filterName = this.getFilterColumnName(item.filter.code);
          const filterDataType = this.getFilterColumnDataType(filter.code);
          const values: string[] = [];
          for (const v of filter.value) {
            values.push(v);
          }
          data = {
            name: filterName,
            code: filter.code,
            value: values,
            operator: filter.operator,
            dataType: filterDataType,
          };
          selectedFilters.add(new FilterColumnModel(data));
        }
      }
    }
    return selectedFilters;
  }


  public getFilterColumnName(code: string) {
    for (const column of this.reportColumns) {
      if (column.code === code) {
        return column.name;
      }
    }
    return code;
  }

  public getFilterColumnDataType(code: string) {
    for (const column of this.reportColumns) {
      if (column.code === code) {
        return column.dataType;
      }
    }
    return 'text';
  }

  public async removeFilterValue(index: number, item: string) {
    if (!this.filterForms || !this.filterForms[index] || !this.filterForms[index].filter) {
      return;
    }

    const filterForm = this.filterForms[index];
    if (!filterForm.filter.value) {
      return;
    }

    filterForm.filter.value = filterForm.filter.value.filter((value: string) => value !== item);
    await this.applyFilter(); // Apply filter after removing value
  }

  public addBlankFilter() {
    if (this.filterForms.length >= 10) {
      this.errorMessage = 'Maximum of 10 filters allowed';
      return;
    }
    for (const item of this.filterForms) {
      if (!item.filter.code) {
        return;
      }
    }
    const blankFilter = new FilterColumnModel({ name: '', code: '', operator: 'eq', value: [], dataType: 'text' });
    this.filterForms.push({filter: blankFilter, loading: false, search: '', dimensionValues: []});
  }

  public addDefaultFilter() {
    if (this.reportColumns.length === 0) {
      return;
    }
    if (this.filterForms.length > 0) {
      return;
    }
    const defaultFilters: any =
      [
      {
        name: 'Product',
        code: 'Item[Item Description]',
        value: [],
        operator: 'eq',
        dataType: 'text',
      },
      {
        name: 'Variant',
        code:'variant',
        dataType: 'text',
        value: [],
        operator: 'eq',
      },
      {
        name: 'Collections',
        code:'product_collections',
        dataType: 'text',
        value: [],
        operator: 'eq',
      },
      {
        name: 'Product Type',
        code: 'product_type',
        dataType: 'text',
        value: [],
        operator: 'eq',
      },

      {
        name: 'Vendor',
        code:'Vendor Name',
        dataType: 'text',
        value: [],
        operator: 'eq',
      },
      {
        name : 'Store Location',
        code: 'Location[Location]',
        value: [],
        operator: 'eq',
        dataType:'text',
      },
      {
        name: 'Product Tags',
        code: 'product_tags',
        dataType:'text',
        value: [],
        operator: 'eq',
      },
      {
        name: 'SKU',
        code:'product_sku',
        dataType: 'text',
        value: [],
        operator: 'eq',
      },
    ];

    for (const data of defaultFilters) {
      let hasColumn: boolean = false;
      for (const column of this.reportColumns) {
        if (data.code === column.code) {
          hasColumn = true;
        }
      }
      if (!hasColumn) {
        continue;
      }
      let exist: boolean = false;
      if (this.initFilters && this.initFilters.items && this.initFilters.items.length > 0) {
        for (const item of this.initFilters.items) {
          if (item.code === data.code) {
            exist = true;
          }
        }
      }
      if (!exist) {
        const filter = new FilterColumnModel(data);
        this.filterForms.push({filter: filter, loading: false, search: '', dimensionValues: []});
        break;
      }
    }
    let index: number = 0;
    if (this.reportColumns && this.reportColumns.length > 0) {
      for (const item of this.filterForms) {
        this.loadFilterDimensionListValue('', index, this.filterForms[index].filter.code, true)
        index = index + 1;
      }
    }
  }

  public addNewFilter(newFilter: FilterColumnModel) {
    const count: number = this.filterForms.length;
    if (count === 0) {
      return;
    }
    const lastFilter = this.filterForms[count - 1].filter;
    if (!lastFilter.code) {
      this.filterForms = this.filterForms.splice(this.filterForms.length - 1, 0);
    }
    this.filterForms.push({filter: newFilter, loading: false, search: '', dimensionValues: []});
    this.applyFilter();
  }

  public async loadFilterDimensionListValue(search: string, index: number, code: string, resetValue: boolean = false) {
    if (!this.filterForms[index]) {
      return;
    }
    const dimension =  this.getDimensionByCode(code);
    if (!dimension || !dimension.code) {
      return;
    }
    if (resetValue) {
      this.filterForms[index].filter.value = [];
    }

    this.currentSearchCode = code;
    this.currentSearchIndex = index;

    const dimensionValues = new FilterDimensionList();
    this.filterForms[index].filter.dataType = dimension?.dataType;
    this.filterForms[index].filter.name = dimension?.name;
    this.filterForms[index].loading = true;
    this.filterForms[index].dimensionValues = [];
    if (dimension && dimension.dataType) {
      this.filterForms[index].filter.dataType = dimension.dataType;
    }
    if (dimension && dimension.code) {
      try {
        dimensionValues.dimension = this.getDimensionByCode(code);
        await dimensionValues.fetch({ keyword: search });
        const values: any = [];
        for (const item of dimensionValues.items) {
          if (item && item.name) {
            values.push({name: item.name});
          }
        }
        this.filterForms[index].dimensionValues = values;
      } catch {
        this.filterForms[index].loading = false;
      }
    }
    this.filterForms[index].loading = false;
  }

  public debouncedLoadFilterDimensionListValue(search: string, index: number, code: string, resetValue: boolean = false) {
    // Clear any existing timeout for this filter index
    if (this.searchTimeouts.has(index)) {
      clearTimeout(this.searchTimeouts.get(index));
    }

    // Mark this search as pending
    if (search && search.trim()) {
      this.pendingSearches.add(index);
    } else {
      this.pendingSearches.delete(index);
    }

    // Set a new timeout
    const timeoutId = setTimeout(() => {
      this.pendingSearches.delete(index);
      this.loadFilterDimensionListValue(search, index, code, resetValue);
      this.searchTimeouts.delete(index);
    }, this.searchDebounceDelay);

    this.searchTimeouts.set(index, timeoutId);
  }

  public getDimensionByCode(code: string) {
    for (const column of this.reportColumns) {
      if (code === column.code) {
        const dimension = new DimensionModel();
        dimension.code = column.luisMapping;
        dimension.fieldCode = column.code;
        dimension.name = column.name;
        dimension.dataType = column.dataType;
        return dimension;
      }
    }
  }

  @Watch('initFilters', { immediate: true, deep: true })
  private async onInitFiltersChange(newVal: any) {
    if (this.initFilters && this.initFilters.items && this.initFilters.items.length > 0) {
      this.assignInitFilter();
    } else {
      // reset all filters
      this.filterForms = [];
      this.addDefaultFilter();
    }
  }
  @Watch('showColumnFilterMenu', { immediate: true, deep: true })
  private async onShowColumnFilterMenuChange(newVal: any) {
    if (newVal && newVal === true) {
      this.columnFilterMenu = true;
    }
  }

  @Watch('reportColumns', { immediate: true, deep: true })
  private async onReportColumnsChanged(newVal: any) {
    if (this.reportColumns && this.reportColumns.length > 0) {
      this.addDefaultFilter();
    }
  }

  public editFilter(index: number) {
    this.columnFilterMenu = true;
  }

  public get hasEmptyFilter() {
    return this.filterForms.some((item: any) => !item.filter.code);
  }

  public async blurAllFilterInputs() {
    // Find and blur all combobox inputs to force them to commit their values
    const inputs = this.$el.querySelectorAll('.v-combobox input');
    inputs.forEach((input: any) => {
      if (input && typeof input.blur === 'function') {
        input.blur();
      }
    });
    // Small delay to ensure blur events are processed
    await new Promise((resolve) => setTimeout(resolve, 50));
  }

  public handleApplyMouseDown() {
    // Capture any uncommitted values on mousedown before click event
    // This ensures we don't miss values even if the user clicks very quickly
    this.addEditingFilterInputValue();
  }

  public beforeDestroy() {
    // Clear all pending search timeouts
    this.clearAllSearchTimeouts();
    // Remove event listeners
    EventBus.$off('add-new-filter');
    EventBus.$off('clear-filter-column');
  }

  public clearAllSearchTimeouts() {
    this.searchTimeouts.forEach((timeout) => {
      clearTimeout(timeout);
    });
    this.searchTimeouts.clear();
    this.pendingSearches.clear();
  }

  public getFilterHint(filterCode: string): string {
    if (filterCode === 'product_sku') {
      return 'Press tab/enter after input, or use comma-separated SKUs (A,B,C)';
    }
    return 'Press tab/enter after input';
  }

  public handlePaste(event: ClipboardEvent, index: number) {
    if (!event.clipboardData || !this.filterForms[index]) {
      return;
    }

    // Only handle comma-separated parsing for SKU filters
    const filterCode = this.filterForms[index].filter.code;
    const isSKUFilter = filterCode === 'product_sku';
    
    if (!isSKUFilter) {
      return; // Let default paste behavior handle non-SKU filters
    }

    const pastedText = event.clipboardData.getData('text');
    
    // Check if the pasted text contains commas
    if (pastedText.includes(',')) {
      // Prevent the default paste behavior
      event.preventDefault();
      
      this.processCommaSeparatedValues(pastedText, index);
    }
    // If no commas detected, let the default paste behavior handle it
  }

  public handleKeydown(event: KeyboardEvent, index: number) {
    // Only handle Enter and Tab keys
    if (event.key !== 'Enter' && event.key !== 'Tab') {
      return;
    }

    if (!this.filterForms[index]) {
      return;
    }

    // Only handle comma-separated parsing for SKU filters
    const filterCode = this.filterForms[index].filter.code;
    const isSKUFilter = filterCode === 'product_sku';
    
    if (!isSKUFilter) {
      return;
    }

    const searchValue = this.filterForms[index].search;
    
    // Check if user typed comma-separated values
    if (searchValue && searchValue.includes(',')) {
      event.preventDefault(); // Prevent default Enter/Tab behavior
      this.processCommaSeparatedValues(searchValue, index);
    }
  }

  private processCommaSeparatedValues(inputText: string, index: number) {
    // Split by commas, trim whitespace, and filter out empty values
    const inputValues = inputText
      .split(',')
      .map(value => value.trim())
      .filter(value => value.length > 0);
    
    // Get current filter values
    const currentValues = this.filterForms[index].filter.value || [];
    
    // Add new values that don't already exist
    const newValues = [...currentValues];
    inputValues.forEach(value => {
      if (!newValues.includes(value)) {
        newValues.push(value);
      }
    });
    
    // Update the filter with the combined values
    this.filterForms[index].filter.value = newValues;
    
    // Clear the search input
    this.filterForms[index].search = '';
  }
}
